import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';

export default function TextAreaControl(props) {

    const [value, setValue] = useState(props.value);

    function onChange(value) {
        setValue(value);
        if (props.onChange)
            props.onChange(value)
    }

    function onBlur(value) {
        setValue(value);
        if (props.onBlur)
            props.onBlur(value)
    }

    return (
        <div>
            <Form.Group className="mb-3">
                <Form.Label>{props.title}<span class="text-danger fw-bold"> {props.required && '*'}</span> </Form.Label>
                <Form.Control as="textarea" rows={3} 
                    type="text"
                    ref={props.inputRef}
					required={props.required}
                    value={value}
					tabindex={props.tabindex}
					className={props.className}
					maxlength={props.maxlength ?props.maxlength:'-1'}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={(e) => onBlur(e.target.value)}
                    placeholder={props.placeholder}
                />
            </Form.Group>
        </div>
    )
}